import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SiteHeader from '@homeaway/react-site-header';
import { Experiment } from '../Experiment';
import { BrandConsolidationBanner } from '../Banner';
import { logExperiment } from '@homeaway/abacus-client-utils';
import { HA_IDA_CAS_HEADER_LOGIN_TEST } from './constants';
import Cookies from 'js-cookie';
import AsyncTransitionBannerHolder from './AsyncTransitionBanners';
import './Header.less';
import { triggerEdapEvent } from '../../utils/edap';

const loginRE = /(def%26service%3D){1}(.*\.com)?.*/;

class Header extends Component {
  constructor(props) {
    super(props);
    this.showAlternateSiteBanner = false;
  }

  componentDidMount() {
    if (this.showAlternateSiteBanner) {
      triggerEdapEvent({ name: 'generic.event', data: { eventcategory: 'rebranding', eventaction: 'alternatesite pop up seen' }});
    }
  }

  handleLoginRedirect = () => {
    const { data: { login: { items: loginItemsArray }}} = this.props;
    const travelerLoginItem = loginItemsArray.find(item => item.cssClass === 'se-traveler-login');
    logExperiment(HA_IDA_CAS_HEADER_LOGIN_TEST);

    // CAS Login URLs need to be double encoded because of how their params are structured:
    // https://{DOMAIN}/auth/traveler/login?service=https://{DOMAIN}/exp/sso/auth?lt=traveler&context=def&service={DOUBLE_ENCODED_RETURN_URL}&kmsi=true
    let doubleEncodedURI = encodeURIComponent(encodeURIComponent(window.location.pathname + window.location.search));

    // if login, perform specific link update
    let travelerLoginURL = travelerLoginItem.link.replace(
      loginRE,
      `$1${doubleEncodedURI}&kmsi=true`
    );
    window.location.assign(travelerLoginURL);
  }

  handleLoginModal = () => {
    const { showLoginModal } = this.props;
    logExperiment(HA_IDA_CAS_HEADER_LOGIN_TEST);
    showLoginModal();
  }

  handleNotifcationMessageDismiss = () => {
    Cookies.set('hideAlternateBanner', true);
    triggerEdapEvent({ name: 'generic.event', data: { eventcategory: 'rebranding', eventaction: 'alternatesite pop up closed' }});
  }

  alternateBannerSiteSwitch = () => {
    const redirectUrl = this.props.data.alternateBannerMessage.redirectURL;
    window.edap.trigger('generic.event', { eventcategory: 'rebranding', eventaction: 'alternatesite banner link clicked' }).then(() => {
      window.location.href = redirectUrl;
    });
  }

  handleAlternateBannerNotificationMessage = () => {
    const { data } = this.props;
    const msg = [];
    if (data.alternateBannerMessage) {
      // eslint-disable-next-line no-script-url
      const alternateBannerMessage = <span>{data.alternateBannerMessage.currentlyViewing} <strong><a href="javascript:void(0);" onClick={this.alternateBannerSiteSwitch}>{data.alternateBannerMessage.switchTo}</a></strong></span>;
      msg.push(alternateBannerMessage);
    }
    return msg;
  }

  shouldDisplayNotificationBar = () => {
    let notificationMessage = this.handleAlternateBannerNotificationMessage();
    const { preferredLocale, geocountry, rebrandHeader } = this.props;
    let displayAlternateBanner = false;
    if (preferredLocale && notificationMessage.length > 0) {
      const userPreferredLocale = preferredLocale.split('_')[1];
      displayAlternateBanner = Cookies.get('hideAlternateBanner') !== 'true';
      displayAlternateBanner = displayAlternateBanner && geocountry && rebrandHeader && userPreferredLocale !== geocountry;
    } else {
      displayAlternateBanner = false;
    }
    this.showAlternateSiteBanner = displayAlternateBanner;
    return displayAlternateBanner;
  }
  render() {
    const { siteName, locale, isTouchDevice, isMobile, isInverse, isUserLogged, currency, data, theme, feedback } = this.props;

    return (
      <React.Fragment>
        <BrandConsolidationBanner />
        {data &&
        <React.Fragment>
          <Experiment name={HA_IDA_CAS_HEADER_LOGIN_TEST}>
            {value =>
              (
                <SiteHeader
                  handleNotificationMessageDismiss={this.handleNotifcationMessageDismiss}
                  dataUrl="/node/home/api/header"
                  fetchUserData={isUserLogged}
                  {...{ isInverse, isTouchDevice, data, siteName, fullLocale: locale, currencyCode: currency, theme }}
                  travelerLoginClickHandler={value === 1 ? this.handleLoginModal : this.handleLoginRedirect}
                  withoutCountryLanguageSelector={false}
                  withoutCurrencySelector={false}
                  {...isMobile && { feedbackComponentLingua: feedback }}
                  notificationMessages={this.handleAlternateBannerNotificationMessage()}
                  displayNotificationBar={this.shouldDisplayNotificationBar()}
                />
              )
            }
          </Experiment>
          <AsyncTransitionBannerHolder {...data} />
        </React.Fragment>
        }
      </React.Fragment>
    );
  }
}

Header.propTypes = {
  data: PropTypes.shape({
    logo: PropTypes.object,
    flags: PropTypes.object,
    scratchpad: PropTypes.object,
    login: PropTypes.object,
    travelerInbox: PropTypes.object,
    help: PropTypes.object,
    birdhouse: PropTypes.object,
    features: PropTypes.object
  }),
  isInverse: PropTypes.bool.isRequired,
  isTouchDevice: PropTypes.bool,
  isUserLogged: PropTypes.bool,
  siteName: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  currency: PropTypes.string
};

Header.defaultProps = {
  isTouchDevice: false,
  isInverse: false
};

export default Header;
